/**
 * lib/brand-logo — ЕДИНЫЙ источник настоящего логотипа Color Lines 98 Online.
 *
 * ЗАЧЕМ / WHY THIS EXISTS: до этого SPA-рейл рисовал ЗАГЛУШКУ (три цветных круга,
 * `ICON_BRAND` в nav-rail.ts) вместо настоящего фирменного логотипа. Owner-критика
 * «контент-страницы сделаны не по правилам» + тикет content-pages-conformance
 * 2026-06-17 (AC-11/12/13): логотип обязан быть НАСТОЯЩИМ и из ОДНОГО источника,
 * общего с SSG-зеркалом (scripts/build-content). Этот модуль — тот единый ствол:
 *   - импортирует канон-SVG `docs/art/logo/colorlines98-logo-concept.svg` как сырой
 *     текст (`?raw`) — ТОТ ЖЕ физический файл, который SSG копирует в dist-content/
 *     logo/ и подключает `<img>`-ом (scripts/build-content/template.ts). Расхождения
 *     двух копий быть не может — источник один файл (AC-11, единый источник как тема).
 *   - отдаёт разметку с зашитым `class="brand-logo"`, чтобы CSS управлял размером
 *     ФОРМУЛОЙ от рейла (AC-13/§0.G.6), а SVG масштабировался через `viewBox` (он в
 *     файле) — без фикс-px-потолка.
 *
 * SCOPE: предоставить SPA-коду (nav-rail) готовую SVG-разметку логотипа из единого
 *   источника. NOT IN SCOPE: размеры/позиция (CSS nav-rail.css), клик→лендинг
 *   (nav-rail onBrandSelect), SSG-вставка (scripts/build-content — копирует тот же файл).
 *
 * Cross-references: тикет AC-11/12/13; docs/art/logo/colorlines98-logo-concept.svg
 *   (единственный физический источник); scripts/build-content/template.ts (SSG-копия
 *   ТОГО ЖЕ файла); responsive-ui §0.G.6/§10.3.
 */

// Канон-логотип как сырой SVG-текст. ТОТ ЖЕ файл, что копирует SSG (единый источник).
import rawLogoSvg from '../../../../docs/art/logo/colorlines98-logo-concept.svg?raw';

/**
 * SVG-разметка логотипа для инлайна в SPA-рейл. Добавляем `class="brand-logo"`
 * (CSS-якорь размера, AC-13) и `aria-hidden` — доступное имя даёт сам кликабельный
 * бренд-контейнер (`aria-label` в nav-rail, AC-12), чтобы не дублировать имя.
 * `viewBox` уже в файле → SVG масштабируется без фикс-px-потолка.
 */
export const BRAND_LOGO_SVG: string = rawLogoSvg
  // Навесить класс-якорь размера на корневой <svg> (CSS управляет размером формулой).
  .replace(/<svg\b/, '<svg class="brand-logo"')
  // role/aria-* из файла предназначены для standalone-документа; в рейле доступное имя
  // несёт кликабельный контейнер → прячем SVG от a11y-дерева (нет двойного объявления).
  .replace(/\srole="[^"]*"/, '')
  .replace(/\saria-labelledby="[^"]*"/, ' aria-hidden="true" focusable="false"');
